import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import '../../CSS/Uniform.css';
import CIcon from '@coreui/icons-react';
import { cilX } from '@coreui/icons';
import globalutil from 'src/util/globalutil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const FEMALE_SUFFIX_IDS = [2, 3, 6, 7]; // Mrs. Ms. She Her

const getDefaultTab = (suffix, selectedSize) => {
  if (!selectedSize) {
    return FEMALE_SUFFIX_IDS.includes(Number(suffix)) ? 'women' : 'men';
  }
  const all = globalutil.uniformsizes() || [];
  const match = all.find((s) => s.id === Number(selectedSize));
  if (match) return match.sortOrder === 2 ? 'women' : 'men';
  return FEMALE_SUFFIX_IDS.includes(Number(suffix)) ? 'women' : 'men';
};

const UniformSizeModal = ({ isOpen, toggle, selectedSize, onSelectSize, suffix }) => {
  const [activeTab, setActiveTab] = useState(() => getDefaultTab(suffix, selectedSize));

  useEffect(() => {
    if (isOpen) setActiveTab(getDefaultTab(suffix, selectedSize));
  }, [isOpen, suffix, selectedSize]);

  const allSizes = globalutil.uniformsizes() || [];
  const menSizes = allSizes.filter((s) => s.sortOrder === 1);
  const womenSizes = allSizes.filter((s) => s.sortOrder === 2);
  const sizes = activeTab === 'men' ? menSizes : womenSizes;

  const handleSelect = (sizeId) => {
    onSelectSize(sizeId);
    toggle();
  };

  const TABS = [
    { key: 'men', label: 'Men' },
    { key: 'women', label: 'Women' },
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md" className="uniform-size-modal">
      <div className="usm-header">
        <span className="usm-header-title">
          <i className="fa fa-tshirt" aria-hidden="true" />
          Uniform Size Chart
        </span>
        <div className="usm-close" onClick={toggle} aria-label="Close">
          <CIcon icon={cilX} />
        </div>
      </div>

      <div className="usm-tab-bar">
        {TABS.map((tab) => (
          <div
            key={tab.key}
            className={`usm-tab ${activeTab === tab.key ? 'usm-tab--active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <ModalBody className="usm-body">
        <p className="usm-hint">
          <i className="fa fa-info-circle" aria-hidden="true" />
          Click a row to select that size
        </p>

        <table className="usm-table">
          <thead>
            <tr>
              <th>Size</th>
              <th>{activeTab === 'men' ? 'Chest' : 'Bust'} (in)</th>
              <th>Waist (in)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sizes.map((size) => {
              const isSelected = Number(selectedSize) === size.id;
              return (
                <tr
                  key={size.id}
                  className={isSelected ? 'usm-row--selected' : ''}
                  onClick={() => handleSelect(size.id)}
                >
                  <td>
                    <span className="usm-size-pill">{size.code}</span>
                  </td>
                  <td>{size.name}</td> {/* bust range */}
                  <td>{size.desc}</td> {/* waist range */}
                  <td>
                    {isSelected ? (
                      <span className="usm-badge usm-badge--selected">
                        <FontAwesomeIcon icon={faCheck} />
                        Selected
                      </span>
                    ) : (
                      <span className="usm-badge usm-badge--pick">Pick</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="usm-footer">
          <i className="fa fa-ruler" aria-hidden="true" />
          All measurements are in inches
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UniformSizeModal;
